import React, { createContext, useContext, useState } from 'react';

// Create a context for user profiles
const UserProfileContext = createContext();

export const useUserProfile = () => useContext(UserProfileContext);

export const UserProfileProvider = ({ children }) => {
  // Define the initial user profile state
  const [userProfile, setUserProfile] = useState({});

  // Function to update the user profile
  function updateUserProfile(newProfile) {
    setUserProfile(newProfile);
  };

  return (
    <UserProfileContext.Provider value={{ userProfile, updateUserProfile }}>
      {children}
    </UserProfileContext.Provider>
  );
};
